var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChatWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2997 2.22012C10.98 2.07387 11.6739 2.00013 12.3697 2.00012C15.1516 1.98651 17.8029 3.17908 19.6383 5.26958C21.4737 7.36009 22.3132 10.1434 21.9397 12.9001C21.3397 17.5001 16.7997 21.2201 12.1597 21.2201H5.49974C4.93361 21.2204 4.40896 20.9232 4.11799 20.4376C3.82702 19.952 3.8125 19.3492 4.07974 18.8501L4.34974 18.3301C4.61846 17.8293 4.5994 17.2231 4.29974 16.7401C2.62144 14.1017 2.3333 10.8113 3.52749 7.92133C4.72167 5.0314 7.24853 2.90416 10.2997 2.22012ZM12.0797 19.7101C16.1564 19.6458 19.6233 16.7184 20.3697 12.7101C20.7088 10.3872 20.0105 8.03257 18.4597 6.27011C16.9237 4.51239 14.704 3.50279 12.3697 3.50012C11.7785 3.50124 11.1889 3.56155 10.6097 3.68012C8.03488 4.25302 5.89952 6.04239 4.88498 8.4773C3.87043 10.9122 4.10347 13.6884 5.50974 15.9201C6.10803 16.86 6.15013 18.0503 5.61974 19.0301L5.34974 19.5401C5.32776 19.5735 5.32776 19.6167 5.34974 19.6501C5.38974 19.7101 5.44974 19.7101 5.44974 19.7101H12.0797Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatWhite);
export default __webpack_public_path__ + "static/media/ic_chat_white.afa53687d1525d3c70e3f8f8bfb294a4.svg";
export { ForwardRef as ReactComponent };